import gql from "graphql-tag";
import { useQuery, useMutation } from "@apollo/react-hooks";

const GET_EDGES = gql`
  query edges {
    edges {
      id
      nodeOne
      nodeTwo
      distance
    }
  }
`;

const GET_EDGE = gql`
  query edge($node: ID!) {
    edge(id: $node) {
      id
      nodeOne
      nodeTwo
      distance
    }
  }
`;

const CREATE_EDGE = gql`
  mutation createEdge($nodeOne: ID!, $nodeTwo: ID!) {
    createEdge(data: {
      nodeOne: $nodeOne
      nodeTwo: $nodeTwo
    }) {
      id
    }
  }
`;

const DELETE_EDGE = gql`
  mutation deleteEdge($id: ID!) {
    deleteEdge(id: $id) {
     id
    }
  }
`;

export function useGetEdge(nodeId:string, options:object = {}) {
  return useQuery(GET_EDGE, {
    fetchPolicy: 'no-cache',
    ...options,
    variables: {
      nodeOne: nodeId,
    }
  });
}

export function useGetEdges(options:any = {}) {
  return useQuery(GET_EDGES, { fetchPolicy: 'no-cache', ...options });
}

export function useCreateEdge() {
  const [createEdgeMutation] = useMutation(CREATE_EDGE);

  const createEdge = async (nodeOne:string, nodeTwo:string) => {
    return await createEdgeMutation({
      variables: { nodeOne, nodeTwo },
    } as any);
  };

  return createEdge;
}

export function useDeleteEdge(edge:string) {
  const [deleteEdgeMutation] = useMutation(DELETE_EDGE);

  const deleteEdge = async (id:string = edge) => {
    return await deleteEdgeMutation({
      variables: { id: id },
    } as any);
  };

  return deleteEdge;
}

